import { render, staticRenderFns } from "./RUTableView.vue?vue&type=template&id=57c68174&scoped=true"
import script from "./RUTableView.vue?vue&type=script&lang=js"
export * from "./RUTableView.vue?vue&type=script&lang=js"
import style0 from "./RUTableView.vue?vue&type=style&index=0&id=57c68174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c68174",
  null
  
)

export default component.exports